<template>
    <div class="c-group-info">
        <v-list-item class="my-3">
            <v-list-item-content>
                <v-list-item-title class="text-h6 font-weight-bold">
                    Group Info
                </v-list-item-title>
            </v-list-item-content>
            <v-spacer></v-spacer>

            <v-btn
                @click="showEditGroupDialog = true"
                depressed
                class="font-weight-bold my-2"
                color="primary"
            >
                {{ $t("animal.editGroup") }}
            </v-btn>
        </v-list-item>
        <v-card flat>
            <v-list>
                <v-row>
                    <v-col col="1.5" class="ml-3">
                        <v-list-item three-line class="green2">
                            <v-list-item-content>
                                <v-list-item-subtitle>
                                    Group Name
                                    <v-tooltip top color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on">
                                        mdi-help-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>Group Name</span>
                                    </v-tooltip>
                                </v-list-item-subtitle>
                                <v-list-item-title class="text-h6 mt-2">
                                    {{ group?.name }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col col="1.5">
                        <v-list-item three-line class="green2">
                            <v-list-item-content>
                                <v-list-item-subtitle>
                                    Number Of Animals 
                                    <v-tooltip top color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on">
                                        mdi-help-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>Number Of Animals</span>
                                    </v-tooltip>
                                </v-list-item-subtitle>
                                <v-list-item-title class="text-h6 mt-2">
                                    {{ group?.animalCounts }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col col="1.5">
                        <v-list-item three-line class="green2">
                            <v-list-item-content>
                                <v-list-item-subtitle>
                                    Assigned Zone
                                    <v-tooltip top color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on">
                                        mdi-help-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>Assigned Zone</span>
                                    </v-tooltip>
                                </v-list-item-subtitle>
                                <v-list-item-title class="text-h6 mt-2">
                                    {{ group?.geofenceZoneId?.geofenceName }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col col="1.5" class="mr-3">
                        <v-list-item three-line class="green2">
                            <v-list-item-content>
                                <v-list-item-subtitle>
                                    Status
                                    <v-tooltip top color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on">
                                        mdi-help-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>Status</span>
                                    </v-tooltip>
                                </v-list-item-subtitle>
                                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                                    {{ group?.status }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-list>
        </v-card>

        <EditGroupDialog
            @group-edit:close="showEditGroupDialog = false"
            @group:updated="onGroupUpdated"
            :dialogI="showEditGroupDialog"
            :_group="group"
            v-if="group && showEditGroupDialog"
        />
    </div>
</template>

<script>
import EditGroupDialog from './EditGroupDialog.vue';

export default {
    components: {
        EditGroupDialog,
    },

    data() {
        return {
            showEditGroupDialog: false,
        }
    },

    methods: {
        onGroupUpdated() {
            this.showEditGroupDialog = false;
            this.$emit('group:updated');
        },
    },

    props: {
        group: {
            required: true,
            type: Object
        },
    },
}
</script>
